import { Input, Component } from '@angular/core';
import { Person } from '../../core-data-model/Person.model';
import { SearchResult } from '../../core-data-model/SearchResult.model';

@Component({
    selector: 'table-icon',
    template: `
        <i
            class="fa layoutCenteredColumn"
            [ngClass]="getClasses()"
            style="font-size: 19px"
        >
        </i>
    `,
    standalone: false
})
export class NewTableIconComponent {
    @Input()
    result: SearchResult;

    // TODO - replace this with abstract-icon
    getClasses() {
        return this.result instanceof Person
            ? 'fa-user color-person--light'
            : 'fa-briefcase color-job--light';
    }
}
